import { s } from '@/theme/tokens';
import { Box } from '@/ui/primitives';
import { metricTrendCardCompactLayout } from './MetricTrendCardFrame.layout';
import { MetricTrendCardSkeleton } from './MetricTrendCardSkeleton';
import {
  buildMetricCardGridColumns,
  buildMetricCardGridPlacement,
} from './StatusMetricCardGridLayout';
import type { ReactElement } from 'react';

type StatusMetricCardsGridSkeletonsProps = {
  count: number;
  maxDesktopColumns?: number;
};

export const StatusMetricCardsGridSkeletons = ({
  count,
  maxDesktopColumns,
}: StatusMetricCardsGridSkeletonsProps): ReactElement => (
  <Box
    sx={{
      width: '100%',
      display: 'grid',
      gridTemplateColumns: buildMetricCardGridColumns(count, maxDesktopColumns),
      gridAutoRows: `${metricTrendCardCompactLayout.minHeight}px`,
      columnGap: s('xl'),
      rowGap: s('xl'),
    }}
  >
    {Array.from({ length: count }).map((_, index) => (
      <MetricTrendCardSkeleton
        key={`metric-card-skeleton-${index}`}
        sx={buildMetricCardGridPlacement(count, index, maxDesktopColumns)}
      />
    ))}
  </Box>
);
